<script setup lang="ts">
import { ref } from "vue";
import { onClickOutside } from "@vueuse/core";

interface IDropdownProps {
  active: boolean;
  contentClass?: string;
  position?: "left" | "right";
  outsideIgnore?: string[];
}

const props = withDefaults(defineProps<IDropdownProps>(), {
  contentClass: undefined,
  position: "left",
  outsideIgnore: undefined,
});
const emit = defineEmits<{
  outsideClick: [];
}>();

const rootElement = ref<HTMLDivElement | null>(null);

onClickOutside(
  rootElement,
  () => {
    if (props.active) {
      emit("outsideClick");
    }
  },
  { ignore: props.outsideIgnore },
);
</script>

<template>
  <div
    ref="rootElement"
    class="dropdown"
    :class="[`dropdown_${props.position}`]"
  >
    <slot name="trigger" />
    <client-only>
      <div
        v-if="props.active"
        class="dropdown-content"
        :class="props.contentClass"
      >
        <slot />
      </div>
    </client-only>
  </div>
</template>

<style lang="postcss">
.dropdown {
  position: relative;
}

.dropdown-content {
  margin-top: 4px;
  position: absolute;
  top: 100%;
  z-index: var(--pl-z-index-overlay);

  .dropdown_left & {
    left: 0;
  }

  .dropdown_right & {
    right: 0;
  }
}
</style>
